import { random } from "remotion";
/**
 * min, max are inclusive.
 */
export function randomInteger(seed, min, max) {
    return Math.floor(random(seed) * (max - min + 1)) + min;
}
/**
 * min, max are inclusive.
 */
export function randomFloat(seed, min, max) {
    return random(seed) * (max - min) + min;
}
/**
 * Splits a range into `zoneCount` zones and returns a random value from one of
 * the zones.
 */
export function randomFromZone(seed, range, zoneCount, 
/** A value between 0 and zoneCount-1 */
zoneNumber) {
    const rangeSize = range.max - range.min;
    const zoneSize = rangeSize / zoneCount;
    const randomValue = randomFloat(seed, 0, zoneSize);
    return range.min + zoneNumber * zoneSize + randomValue;
}
